import React, { useContext, useEffect, useState } from "react";
import { Form, Input, Select, Switch, AutoComplete } from "antd";
import { WarehousesContext } from "src/shared";
import debounce from "lodash.debounce";

export default function Warehouses({
  formContext,
  record,
  handleIsChanges,
  switchButton,
  setChangeData,
}) {
  const { initialData } = useContext(WarehousesContext);
  const [parent, setParent] = useState();
  const [optionsLocation, setOptionsLocations] = useState([]);
  const { TextArea } = Input;
  const formItemLayout = { labelCol: { span: 5 }, wrapperCol: { span: 17 } };

  const types = [
    { value: "warehouse", label: "Склад" },
    { value: "shop", label: "Магазин" },
    { value: "area", label: "Участок" },
  ];

  useEffect(() => {
    if (initialData.length !== 0) {
      const parentSelect = [];
      for (let item of initialData) {
        parentSelect.push({ value: item.id, label: item.name });
      }
      setParent(parentSelect);
    }
  }, [initialData]);

  const onChangeLocation = async (value) => {
    if (!value) {
      setOptionsLocations([]);
      return;
    }
    try {
      const res = await fetch(
        `https://dev.tablecrm.com/api/v1/autosuggestions/geolocation?query=${encodeURIComponent(
          value
        )}&limit=5`
      );
      const data = await res.json();

      console.log(data);

      if (data?.suggestions.length) {
        const uniqueSuggestions = Array.from(new Set(data.suggestions))

        setOptionsLocations(
          uniqueSuggestions.map((suggest) => ({
            value: suggest,
            label: suggest,
          }))
        );
        console.log(data.suggestions)
      } else {
        setOptionsLocations([
          {
            value: value,
            label: value,
          },
        ]);
      }
    } catch (err) {
      console.error("Ошибка загрузки городов:", err);
    }
  };

  const debounceOnChangeLocation = debounce(onChangeLocation, 500);

  const onValuesChange = () => {
    setChangeData(true);
  };

  const validateMessages = {
    /* eslint-disable no-template-curly-in-string */
    required: "Поле обязательно для ввода!",
  };

  return (
    <Form
      {...formItemLayout}
      form={formContext}
      initialValues={record}
      onChange={handleIsChanges}
      layout={"horizontal"}
      style={{ maxWidth: "100%" }}
      onValuesChange={onValuesChange}
      validateMessages={validateMessages}
    >
      <Form.Item rules={[{ required: true }]} label={"Название"} name={"name"}>
        <Input />
      </Form.Item>
      <Form.Item rules={[{ required: true }]} label={"Тип помещения"} name={"type"}>
        <Select options={types} />
      </Form.Item>
      <Form.Item label={"Описание"} name={"description"}>
        <TextArea rows={4} />
      </Form.Item>
      <Form.Item rules={[{ required: true }]} label={"Адрес"} name={"address"}>
        <AutoComplete
          options={optionsLocation}
          onSearch={debounceOnChangeLocation}
          onSelect={(value) => {
            formContext.setFieldsValue({ address: value });
          }}
          filterOption={false}
        />
      </Form.Item>
      <Form.Item label={"Телефон"} name={"phone"}>
        <Input />
      </Form.Item>
      <Form.Item label={"Родитель"} name={"parent"}>
        <Select options={parent} />
      </Form.Item>
      {switchButton ? (
        <Form.Item label={"Статус"} name={"status"}>
          <Switch />
        </Form.Item>
      ) : null}
    </Form>
  );
}
